import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-anniversary-52nd',
  templateUrl: './anniversary-52nd.component.html',
  styleUrls: ['./anniversary-52nd.component.scss']
})
export class Anniversary52ndComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/anniversary-52nd/anniversary-52nd.component.ts